import GetDocumentViaUrl from './GetDocumentViaUrl'

export default GetDocumentViaUrl
